import React from "react";
// import { FaTruck, FaShoppingCart, FaLeaf } from "react-icons/fa";
import farmerIcon from "../../assets/icons/famer-icon.svg";
import marketerIcon from "../../assets/icons/markrter-icon.svg";
import transporterIcon from "../../assets/icons/transport-icon.svg";
import verifiedIcon from "../../assets/icons/verified-icon.svg";
import qualityIcon from "../../assets/icons/network-icon.svg";
import coverageIcon from "../../assets/icons/location-icon.svg";

const roles = [
  {
    icon: <img src={farmerIcon} alt="Farmer" className="w-16 h-16" />,
    title: "Farmer",
    description: "List your produce, manage orders, and get paid securely",
    points: [
      "List produce easily",
      "Secure payments",
      "Order management",
      "KYC verification",
    ],
    buttonText: "Get Started as Farmer",
    color: "green",
  },
  {
    icon: <img src={marketerIcon} alt="Marketer/Buyer" className="w-16 h-16" />,
    title: "Marketer/Buyer",
    description: "Browse verified produce, place orders with escrow protection",
    points: [
      "Verified listings only",
      "Make payments",
      "Quality assurance",
      "Contract orders",
    ],
    buttonText: "Get Started as Marketer/Buyer",
    color: "blue",
  },
  {
    icon: (
      <img src={transporterIcon} alt="Transport Agent" className="w-16 h-16" />
    ),
    title: "Transport Agent",
    description: "Accept delivery jobs, optimize routes, and earn instantly",
    points: [
      "Flexible job board",
      "Route optimization",
      "Instant payouts",
      "OTP verification",
    ],
    buttonText: "Get Started as Transport Agent",
    color: "orange",
  },
];

const highlights = [
  {
    icon: (
      <img src={verifiedIcon} alt="Secure & Verified" className="w-16 h-16" />
    ),
    title: "Secure & Verified",
    description: "KYC verification and escrow payments for your safety",
  },
  {
    icon: (
      <img src={qualityIcon} alt="Quality Assurance" className="w-16 h-16" />
    ),
    title: "Growing Network",
    description: "Join thousands of farmers, buyers, and transporters",
  },
  {
    icon: (
      <img src={coverageIcon} alt="Nationwide Coverage" className="w-16 h-16" />
    ),
    title: "Nationwide Coverage (Offline Access)",
    description: "Available across all 774 LGAs in Nigeria",
  },
];

// Map of color classes to avoid dynamic class issues in Tailwind
const colorMap = {
  green: {
    bg: "bg-green-50",
    text: "text-green-600",
    btn: "bg-green-600 hover:bg-green-700",
  },
  blue: {
    bg: "bg-blue-50",
    text: "text-blue-600",
    btn: "bg-blue-600 hover:bg-blue-700",
  },
  orange: {
    bg: "bg-orange-50",
    text: "text-orange-600",
    btn: "bg-orange-600 hover:bg-orange-700",
  },
};

const ChooseRole = () => {
  return (
    <section className="py-16 bg-white">
      {/* Header */}
      <div className="text-center mb-12 px-4">
        <h2 className="text-3xl md:text-4xl font-bold mb-2">
          Choose Your Role
        </h2>
        <p className="text-gray-600 max-w-2xl mx-auto">
          Join thousands of users already connecting through AgroLink. Select
          your role to get started.
        </p>
      </div>

      {/* Role Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-10 max-w-6xl mx-auto px-4">
        {roles.map((role, index) => {
          const colors = colorMap[role.color];
          return (
            <div
              key={index}
              className={`rounded-lg shadow-lg p-6 text-center ${colors.bg}`}
            >
              <div className="flex justify-center items-center mb-4">
                <div className={`${colors.text}`}>{role.icon}</div>
              </div>
              <h3 className="text-xl font-semibold mb-2">{role.title}</h3>
              <p className="text-gray-700 text-sm mb-4">{role.description}</p>
              <ul className="text-left text-sm mb-6 text-gray-700 list-disc list-inside">
                {role.points.map((point, i) => (
                  <li key={i} className="mb-2">
                    {point}
                  </li>
                ))}
              </ul>
              <button
                className={`w-full px-4 py-2 text-white rounded font-medium ${colors.btn} transition`}
              >
                {role.buttonText}
              </button>
            </div>
          );
        })}
      </div>

      {/* Highlights */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-20 px-4 max-w-6xl mx-auto shadow-lg p-8 bg-gray-50 rounded-lg">
        {highlights.map((item, i) => (
          <div key={i} className="text-center">
            <div className="flex justify-center items-center mb-4">
              <div className="text-3xl mb-2">{item.icon}</div>
            </div>
            <h4 className="font-semibold text-lg mb-1">{item.title}</h4>
            <p className="text-gray-600 text-sm">{item.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ChooseRole;
